import { ConfirmationService, MessageService } from 'primeng/api';
import { DtoPedido } from './../dominio/DtoPedido';
import { DtoPersonamast } from 'src/app/erp/core/personamast/dominio/DtoPersonamast';
import { PersonamastSelectorComponent } from './../../../core/personamast/vista/selector/personamastselector.component';
import { FiltroCoPedido } from './../dominio/FiltroCoPedido';
import { CoPedidosServicio } from './../servicio/copedidos.service';
//import { MessageService } from 'primeng/components/common/messageservice';
import { NoAuthorizationInterceptor } from './../../../../util/interceptor/NoAuthorizationInterceptor';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { SelectItem, LazyLoadEvent } from 'primeng/primeng';
import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MaMiscelaneosdetalleServicio } from '../../../core/mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { Router } from '@angular/router';
import { CoDocumentoPk } from '../../codocumento/dominio/CoDocumento';
import { WhAlmacenmastService } from '../../../logistica/whalmacenmast/servicio/whalmacenmast.servicio';
import { PersonamastServicio } from './../../../core/personamast/service/personamast.service';
import { Table } from 'primeng/table';
import { CoDocumentoServicio } from '../../codocumento/service/codocumento.service';
import { ElementRef} from '@angular/core';
import { Renderer} from '@angular/core';




@Component({
    selector: 'app-pedido-listado',
    templateUrl: './pedido-listado.component.html'
})
export class PedidoListadoComponent extends PrincipalBaseComponent implements OnInit {

    PG_DOCUMENTOS_LISTAR: number = 0;
    PG_REALIZAR_COBRANZA: number = 1;
    PG_REALIZAR_COBRANZA_PAGO: number = 2;
    PG_CLIENTE_SELECTOR: number = 3;
    PG_ACTUAL: number = 0;

    @ViewChild(PersonamastSelectorComponent,{static:false}) personamastSelectorComponent: PersonamastSelectorComponent;
    lstEstados: SelectItem[] = [];
    lstMoneda: SelectItem[] = [];
    filtro: FiltroCoPedido = new FiltroCoPedido();
    seleccionados: DtoPedido = new DtoPedido();
    filtrofechas: Boolean = true;
    cantidadMoroso: number;
    numerodocMoroso: Boolean = false;
    beanDocumentoContinuar: DtoPedido = new DtoPedido();
    numerodoc: string = '';
    urlImprimir: String = '';
    esAprobador: Boolean = false;
    listaAlmacen: SelectItem[] = [];
    lstClientes: any[];
    dtoPersonamast: DtoPersonamast =  new DtoPersonamast();

    constructor(
        private renderer: Renderer,
        private router: Router,
        private confirmationService: ConfirmationService,
        private whAlmacenmastService: WhAlmacenmastService,
        private maMiscelaneosdetalleServicio: MaMiscelaneosdetalleServicio,
        private coPedidosServicio: CoPedidosServicio,
        private coDocumentoServicio:CoDocumentoServicio,
        private cdref: ChangeDetectorRef,
        private personamastServicio: PersonamastServicio,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService
    ) { super(noAuthorizationInterceptor, messageService); }
    paginacion: any = new Object();
    @ViewChild(Table,{static:false}) dt: Table;
    @ViewChild('target',{static:false}) target;


    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngOnInit() {
        super.ngOnInit();
        this.cargarEstados();
        this.cargarAlmacenes();
        this.cargarMonedas();
        this.filtro.fechadoc = new Date();
        this.filtro.fechavenc = new Date();

        this.coPedidosServicio.esAprobador().then(
            resp => {
                if (resp !== undefined || resp !== null) {
                    if (resp.esAprobador === 'S') {
                        this.esAprobador = true;
                    } else {
                        this.esAprobador = false;
                    }
                }
            }
        )


        
    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.buscar();
        }
    }

    filterClienteSingle(event) {
        let query = event.query;
        this.personamastServicio.listarClientes(query).then(
            res => {
                this.lstClientes = res;
            }
        );
    }

    toggleVisibility(e) {
        if (e) {
            this.filtro.fechadoc = new Date();
            this.filtro.fechavenc = new Date();
        } else {
            this.filtro.fechadoc = null;
            this.filtro.fechavenc = null;
        }
    }

    captureId(event: any) {
        this.dtoPersonamast.persona= event.persona;
        if(!this.estaVacio(this.dtoPersonamast.busqueda)){
            this.dtoPersonamast.busqueda=this.dtoPersonamast.busqueda.trim();
            this.filtro.nombreCliente=this.dtoPersonamast.busqueda.trim();
        }
        this.filtro.clientenum=event.persona;
    }

    nuevo() {
        sessionStorage.setItem('filtrosItem', 'LIMPIAR');
        this.router.navigate(['royal/cliente-listado', 'PEDIDO'], { skipLocationChange: true });
    }

    nuevoPedido() {
        sessionStorage.setItem('filtrosItem', 'LIMPIAR');
        this.router.navigate(['/royal/pedido-mantenimiento', 'NUEVO'], { skipLocationChange: true });
    }

    cargarEstados() {
        this.bloquearPagina();
        this.lstEstados.push({ label: ' TODO ESTADOS', value: null });
        this.maMiscelaneosdetalleServicio.listarPorCabecera('CO', '999999', 'PEDEST').then(
            res => {
                res.forEach(
                    reg => {
                        this.lstEstados.push({ label: reg.descripcionlocal, value: reg.pk.codigoelemento.trim() });
                    }
                );
                this.desbloquearPagina();
            }
        );
    }

    cargarAlmacenes() {
        this.listaAlmacen.push({ label: 'TODO ALMACÉN', value: null });
        this.whAlmacenmastService.listarActivosHuemura('V').then(
            res => {
                res.forEach(
                    reg => {
                        this.listaAlmacen.push({ label: reg.descripcionLocal, value: reg.almacenCodigo.trim() });
                    }
                );
            }
        );
    }

    cargarMonedas() {
        this.lstMoneda.push({ label: 'TODO MONEDA', value: null });
        this.lstMoneda.push({ label: 'Dolares', value: 'EX' });
        this.lstMoneda.push({ label: 'Soles', value: 'LO' });
    }
    si(e) {
        // console.log(e.id)
        // var esconde=document.getElementsByClassName('j_sDuo') as HTMLCollectionOf<HTMLElement>;
        // if (esconde.length != 0) {
        //     for(var y=0;y<esconde.length;y++){
        //         esconde[y].classList.toggle('esconde') ;
        //     }
           
        //   }
// console.log(e.id)

        
    }
   

    cargarPaginacion(event: LazyLoadEvent) {
        this.bloquearPagina();

        const ss = sessionStorage.getItem('filtrosPedidos');

        if (ss !== undefined && ss !== null && ss !== 'LIMPIAR') {
            const prefiltro = JSON.parse(ss) as FiltroCoPedido;
            if(prefiltro.fechadoc>new Date()){
                prefiltro.fechadoc=new Date();
                prefiltro.fechavenc=new Date();
            }
            this.filtro = prefiltro;

            if(this.dtoPersonamast.persona==undefined && !this.estaVacio(this.filtro.nombreCliente)){
                this.dtoPersonamast=new DtoPersonamast();
                this.dtoPersonamast.busqueda=this.filtro.nombreCliente;
               }
        }else{
            if (this.dtoPersonamast.persona == undefined) {
                this.filtro.nombreCliente = undefined;
                this.filtro.clientenum = undefined;
            }
        }

        if (this.filtrofechas === false) {
            this.filtro.fechadoc = null;
            this.filtro.fechavenc = null;

            if (this.filtro.fechadoc != null && this.filtro.fechavenc != null) {
                if (this.filtro.fechadoc > this.filtro.fechavenc) {
                    this.mostrarMensajeAdvertencia('La fecha de Vencimiento debe se mayor o igual que la fecha de Documento');
                    this.desbloquearPagina();
                    return;
                }
            }

        }

       // this.filtro.clientenum=this.dtoPersonamast.persona;
      
        this.filtro.paginacion.listaResultado = [];
        this.filtro.paginacion.registroInicio = event.first;
        this.filtro.paginacion.cantidadRegistrosDevolver = event.rows;

        sessionStorage.setItem('filtrosPedidos', JSON.stringify(this.filtro));

        this.coPedidosServicio.listarPedidosPaginacion(this.filtro)
            .then(res => {
                this.filtro.paginacion = res;
                this.desbloquearPagina();
            });

    }

    ver(bean: DtoPedido) {
        const pk = new CoDocumentoPk();
        pk.companiasocio = bean.companiaSocio;
        pk.numerodocumento = bean.numeroDocumento;
        pk.tipodocumento = bean.tipoDocumento;
        this.router.navigate(['/royal/pedido-mantenimiento', 'VER', JSON.stringify(pk)], { skipLocationChange: true });
    }

    buscar() {
        if (this.filtrofechas === false) {
            if (this.estaVacio(this.dtoPersonamast.persona) && this.estaVacio(this.filtro.numerodoc)) {
                this.mostrarMensajeAdvertencia('Debe Seleccionar un cliente o introducir un número de Pedido');
                return;
            } else if (this.dtoPersonamast.persona === undefined && this.filtro.numerodoc === undefined) {
                this.mostrarMensajeAdvertencia('Debe Seleccionar un cliente o introducir un número de Pedido');
                return;
            }
        }

        sessionStorage.setItem('filtrosPedidos', 'LIMPIAR');
        this.dt.reset();
    }

    cancelarAccionSelector() {
        this.PG_ACTUAL = this.PG_DOCUMENTOS_LISTAR;
    }

    limpiarCliente() {
        this.dtoPersonamast = new DtoPersonamast();
    }

    
    imprimir() {

        if(this.seleccionados===undefined || this.seleccionados===null){
            this.messageService.add({ severity: 'info', summary: 'Error', detail: 'Debe Seleccionar un Registro' });
            return;
        }

        if(this.seleccionados.numeroDocumento ===undefined){
            this.messageService.add({ severity: 'info', summary: 'Error', detail: 'Debe Seleccionar un Registro' });
            return;
        }


        this.bloquearPagina();
        this.filtro.numerodoc= this.seleccionados.numeroDocumento;
        this.filtro.usuarioActualCompania= this.seleccionados.companiaSocio;
        this.coPedidosServicio.imprimir(
            this.filtro
        )
            .then(respuesta => {
                if (respuesta) {
                    this.desbloquearPagina();
                    const file = new Blob([respuesta], { type: 'application/pdf' });
                    this.urlImprimir = URL.createObjectURL(file);
                    window.open(this.urlImprimir.toString());
                    this.seleccionados=undefined;
                }
            });
    }

    // imprimir() {

    //     if (this.seleccionados === undefined || this.seleccionados === null) {
    //         this.messageService.add({ severity: 'info', summary: 'Error', detail: 'Debe Seleccionar un Registro' });
    //         return;
    //     }

    //     if (this.seleccionados.numeroDocumento === undefined) {
    //         this.messageService.add({ severity: 'info', summary: 'Error', detail: 'Debe Seleccionar un Registro' });
    //         return;
    //     }


    //     this.bloquearPagina();
    //     this.filtro.numerodoc = this.seleccionados.numeroDocumento;
    //     this.filtro.usuarioActualCompania = this.seleccionados.companiaSocio;
    //     this.coPedidosServicio.imprimir(
    //         this.filtro
    //     )
    //         .then(respuesta => {
    //             if (respuesta) {
    //                 this.desbloquearPagina();
    //                 const file = new Blob([respuesta], { type: 'application/pdf' });
    //                 this.urlImprimir = URL.createObjectURL(file);
    //                 window.open(this.urlImprimir.toString());
    //                 this.seleccionados = undefined;
    //             }
    //         });
    // }




    // #######################################################
    // #######     APROBAR, DESAPROAR, ANULAR           ######
    // #######################################################
    anular(bean: DtoPedido) {
        console.log(bean.estado);
        if (bean.estado.trim() === 'PR' || bean.estado.trim() === 'RV') {
            this.confirmationService.confirm({
                header: 'Confirmación',
                icon: 'fa fa-question-circle',
                message: this.getMensajePreguntaAnular(),
                accept: () => {
                    this.bloquearPagina();
                    this.anularValidado(bean);
                }
            });
        } else if (bean.estado.trim() !== 'PR' || bean.estado.trim() !== 'RV') {
            this.messageService.add({ severity: 'info', summary: 'Error', detail: 'Solo se pueden anular documentos en Preparación o Revisado' });
        }
    }

    anularValidado(bean: DtoPedido) {
        this.coPedidosServicio.solicitudAnular(bean).then(
            respose => {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Información', detail: this.getMensajeAnulado(bean.numeroDocumento) });
                this.dt.reset();
            }
        );
    }

    aprobar(bean: DtoPedido) {

        if (bean.estado !== 'PR') {
            this.mostrarMensajeAdvertencia('Solo se puede Revisar en estado de Preparación');
            return;
        }

        if (bean.clienteNombre.trim() === 'CLIENTES VARIOS') {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Información', detail: 'Debe editar y especificar un cliente válido en el pedido.' });
            return;
        }

        if (bean.estado === 'PR') {
            this.confirmationService.confirm({
                header: 'Confirmación',
                icon: 'fa fa-question-circle',
                message: '¿Desea Revisar este registro?',
                accept: () => {
                    this.bloquearPagina();
                    const pk: DtoPedido = new DtoPedido();
                    pk.companiaSocio = bean.companiaSocio;
                    pk.numeroDocumento = bean.numeroDocumento;
                    pk.tipoDocumento = bean.tipoDocumento;
                    pk.estado = 'RV';
                    this.coDocumentoServicio.aprobarRechazarPedido(pk).then(
                        resp => {
                            if (resp !== null) {
                                this.mostrarMensajeExito('El pedido N° ' + bean.numeroDocumento + ' se ha Revisado correctamente');
                                this.desbloquearPagina();
                                this.dt.reset();
                            } else {
                                this.desbloquearPagina();
                            }
                        }
                    );
                }
            });
        } else if (bean.estado === 'AP') {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Información', detail: 'El Documento ya se encuentra aprobado.' });
        }
    }

    aprobarValidado(bean: DtoPedido) {
        this.coPedidosServicio.solicitudAprobarUno(bean).then(
            respose => {
                console.log(respose);
                if (respose > 0) {
                    this.cantidadMoroso = respose;
                    this.numerodocMoroso = true;
                    this.beanDocumentoContinuar = bean;

                } else if (respose === 0) {
                    this.bloquearPagina();
                    const documentoPk = new CoDocumentoPk;
                    documentoPk.companiasocio = bean.companiaSocio;
                    documentoPk.numerodocumento = bean.numeroDocumento;
                    documentoPk.tipodocumento = 'PE';

                    this.coPedidosServicio.obtenerCompletoPorId(documentoPk).then(
                        x => {
                            x.rutadespacho = this.trim(x.rutadespacho);
                            x.almacencodigo = this.trim(x.almacencodigo);
                            x.iv_action = 'Update';
                            this.desbloquearPagina();
                            this.router.navigate(['/royal/linea-credito', 'APROBAR', JSON.stringify(x)], { skipLocationChange: true });
                        }
                    );
                }
            }
        );
    }

    continuarMoroso() {
        this.numerodocMoroso = false;
        this.confirmationService.confirm({
            header: 'Confirmación',
            icon: 'fa fa-question-circle',
            message: this.getMensajeDocMorososContinuar(),
            accept: () => {
                this.bloquearPagina();
                const documentoPk = new CoDocumentoPk;
                documentoPk.companiasocio = this.beanDocumentoContinuar.companiaSocio;
                documentoPk.numerodocumento = this.beanDocumentoContinuar.numeroDocumento;
                documentoPk.tipodocumento = 'PE';

                this.coPedidosServicio.obtenerCompletoPorId(documentoPk).then(
                    x => {
                        x.rutadespacho = this.trim(x.rutadespacho);
                        x.almacencodigo = this.trim(x.almacencodigo);
                        x.iv_action = 'Update';
                        this.desbloquearPagina();
                        this.router.navigate(['/royal/linea-credito', 'APROBAR', JSON.stringify(x)], { skipLocationChange: true });

                    }
                );
            }
        });
    }

    desaprobar(bean: DtoPedido) {
        if (bean.estado === 'AP') {
            this.coPedidosServicio.validarReject(bean).then(
                response => {
                    if (response > 0) {
                        this.messageService.add({ severity: 'info', summary: 'Información', detail: 'El pedido no puede desaprobarse, hay despachos relacionados al pedido, primero debe anularlos.' });
                    }
                    if (response <= 0) {
                        this.confirmationService.confirm({
                            header: 'Confirmación',
                            icon: 'fa fa-question-circle',
                            message: this.getMensajePreguntaDesaprobar(),
                            accept: () => {
                                this.bloquearPagina();
                                this.desaprobarValidado(bean);
                            }
                        });
                    }
                }
            );
        }
        if (bean.estado !== 'AP') {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Información', detail: 'Solo se puede desaprobar documentos aprobados' });
        }
    }

    desaprobarValidado(bean: DtoPedido) {
        this.coPedidosServicio.solicitudDesAprobar(bean).then(
            respose => {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Información', detail: 'El Pedido ' + bean.numeroDocumento + ' se desaprobó con exito ' });
                this.dt.reset();
            }
        );
    }

    editar(bean: DtoPedido) {
        sessionStorage.setItem('filtrosItem', 'LIMPIAR');
        let ll_retorno;
        if (bean.estado === 'PR') {
            ll_retorno = 0;
        } else {
            ll_retorno = -1;
        }

        if (ll_retorno === -1) {
            this.mostrarMensajeAdvertencia('El Estado del Documento no permite modificaciones');
            return;
        }
        const pk = new CoDocumentoPk();
        pk.companiasocio = bean.companiaSocio;
        pk.numerodocumento = bean.numeroDocumento;
        pk.tipodocumento = bean.tipoDocumento;
        this.router.navigate(['/royal/pedido-mantenimiento', 'EDITAR', JSON.stringify(pk)], { skipLocationChange: true });
    }

    verseguimiento(bean: DtoPedido) {
        this.numerodoc = bean.numeroDocumento;
        this.router.navigate(['royal/pedido_seguimiento', this.numerodoc], { skipLocationChange: true });

    }


}
